import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';
import { EffectFade, Autoplay } from 'swiper/modules';

const MODULE = document.querySelectorAll('[data-module="hero_home"]');

class HeroHome {
    constructor() {
        this.components = MODULE;
        this.init();
    }

    init() {
        this.components.forEach((component) => {
            const swiperEl = component.querySelector('.swiper');
            if (swiperEl) this.initSwiper(component, swiperEl);
        });
    }

    initSwiper(component, swiperEl) {
        const swiper = new Swiper(swiperEl, {
            modules: [EffectFade, Autoplay],
            effect: 'fade',
            fadeEffect: { crossFade: true },
            slidesPerView: 1,
            loop: false,
            rewind: true,
            autoplay: {
                delay: 7000,
                disableOnInteraction: false,
            },
        });

        component.addEventListener('click', (event) => {
            const control = event.target.closest('[data-hero-goto]');
            if (!control || !swiperEl.contains(control)) return;

            const index = Number(control.dataset.heroGoto);
            if (Number.isNaN(index)) return;

            swiper.slideTo(index);
        });
    }
}

(() => {
    if (MODULE.length) {
        new HeroHome();
    }
})();

export default HeroHome;
